import React, { useEffect, useState, useMemo } from 'react';
import { ReactSortable,  } from "react-sortablejs";
import { useForm } from "react-hook-form"

import { alertRoutine } from '../../../redux/Alerts/routines'

import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux'

import Button from '@material-ui/core/Button';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import DragHandleIcon from '@material-ui/icons/DragHandle';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';

import { isMobile } from 'react-device-detect';

import { postParamRoutine, putParamRoutine } from '../../../redux/Params/routines'
import { makeParamsSelector } from '../../../redux/Params/selectors'
import { collectionKeysEqualityFn } from '../../../utils/equality';
import { v4 as uuidv4} from 'uuid';
import { Box } from '@material-ui/core';

const CustomList = React.forwardRef((props, ref) => <List {...props} ref={ref} dense component="div">{props.children}</List>)

function DialogBody ({type, title}) {

  //make selector for good memoization
  const paramsSelector = useMemo(makeParamsSelector, [])
  const  params =  useSelector(state => paramsSelector(state, `${type}`, collectionKeysEqualityFn(['id', 'updatedAt'])))
  const param = params[0]
  const list = param?.value || []
  
  const dispatch = useDispatch()
  const { register, handleSubmit, reset } = useForm()
  const [elements, setElements] = useState(list)
  const { t } = useTranslation()

  useEffect(() => {
    setElements(list)
  }, [list.map(l=>l.id).join(), param?.updatedAt])

  useEffect(() => {
    if(elements.map(l=>l.id).join() !== list.map(l=>l.id).join())
      saveParam(elements)
  }, [elements.map(l=>l.id).join()])


  const saveParam = (values) => {
    if(param) {
      dispatch(putParamRoutine({
        id: param.id,
        values: {
          value: values
        }
      }))
    }
    else {
      dispatch(postParamRoutine({
        name: `${type}`,
        value: values
      }))
    }
  }

  const onSubmit = (data) => {
    console.log(data)
    if(!data.name)
      return

    if(!data.id) {
      saveParam([...list, {...data, id: uuidv4()}])
    }
    else {
      const index = list.findIndex(elt => elt.id === data.id)
      saveParam([...list.slice(0, index), data, ...list.slice(index + 1)])
    }
    reset({
      id: "",
      name: '',
    })
    setSelected()

  }

  const handleDelete = (index) => (e) => {
    e.stopPropagation()
    saveParam([...list.slice(0, index), ...list.slice(index + 1)])
    reset({
      id: "",
      name: '',
    })
  }

  const classes = {}


  const [selected, setSelected] = useState()
    
    const handleSelect = React.useCallback((elt) => () => { 
      setSelected(oldSelected => {
        if(oldSelected?.id === elt.id)
          return;
        else
          return elt
      })
    }, [])

  useEffect(() => {
      console.log('selected', selected)
      reset({
        id: selected?.id || '',
        name: selected?.name || '',
      })
    }, [selected?.id])

  console.log('list', list)
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div style={{marginBottom: 16}}>
          <input type="hidden" {...register('id')} />
          <TextField
            placeholder={title}
            fullWidth
            variant='outlined'
            size="small"
            autoComplete="off"
            InputProps={{
              endAdornment: 
                <InputAdornment position="end">
                  <Button
                    variant='outlined'
                    style={{
                      marginRight:-15,
                      borderRight: '1px solid transparent',
                      borderTop: '1px solid transparent',
                      borderBottom: '1px solid transparent',
                      padding: '7px 15px',
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0,
                    }}
                    type="submit"
                  >
                    {
                      !selected ?
                      t('common:interface.add') :
                        t('common:interface.edit')
                    }
                  </Button>
                </InputAdornment>
              
            }}
            {...register('name')}
          />
        </div> 
        <Paper variant="outlined">
          {
            elements.length === 0 &&
            <List>
              <ListItem >
                <Box textAlign="center" flex={1}>
                  {t('common:interface.Aucun élément')}
                </Box>
              </ListItem>
            </List>
          }
          {
            elements.length > 0 &&
            <ReactSortable
              tag={CustomList}
              list={elements}
              setList={setElements}
              forceFallback
              fallbackTolerance={3}
              //className={classes.list}
              handle={isMobile? '.list-handle' : null}
            >
              {
                elements.map((elt, index) => {
                  return (
                    <ListItem key={elt.id} className={classes.listItem} onClick={handleSelect(elt)} selected={elt.id === selected?.id}>
                      <ListItemText
                        primary={elt.name}
                      />
                      <IconButton disableRipple size="small" onClick={handleDelete(index)}>
                        <DeleteOutlineIcon />
                      </IconButton>
                      {isMobile && <DragHandleIcon color="action" className="list-handle"/>}
                    </ListItem>
                  )
                })
              }
            </ReactSortable>
          }
          
        </Paper>
        
      </form>
      {/* <Divider /> */}

    </div>
  )
}

export const simpleParamsFormActionCreator = ({type, title}) => (
  alertRoutine.show({
    type: 'dialog',
    //maxWidth: 'xs',
    //title: 'Modifier les '+type, //i18n.t('cephalo:interface.reset_analyse'),
    content: <DialogBody type={type} title={title}/>,
  })
)
